import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProfilePage from './Profile/ProfilePage';
import DesktopSuperAdminLayout from 'shared/components/layout/DesktopSuperAdminLayout';
import OrganizationsPage from './Organizations/OrganizationsPage';
import Reports from './Reports/Reports';
import OrganizationForm from './Organizations/OrganizationForm';
import DesktopAdminLayout from 'shared/components/layout/DesktopAdminLayout';
import UsersPage from './Users/UsersPage';
import UserForm from './Users/UserForm';
import BadgeForm from './Badges/BadgeForm';
import BadgesPage from './Badges/BadgesPage';
import BannersPage from './Banners/BannersPage';
import BannerForm from './Banners/BannerForm';
import PackagesPage from './Packages/PackagesPage';
import PackageForm from './Packages/PackageForm';
import StaticPagesPage from './StaticPages/StaticPagesPage';
import StaticPageForm from './StaticPages/StaticPageForm';
import ReviewsPage from './Reviews/ReviewsPage';
import CategoriesPage from './Categories/CategoriesPage';
import CategoryForm from './Categories/CategoryForm';
import LevelsPage from './Levels/LevelsPage';
import LevelForm from './Levels/LevelForm';
import CoursesPage from './Courses/CoursesPage';
import CourseForm from './Courses/CourseForm';
import CourseView from './Courses/CourseView';
import CurriculumForm from './Curriculums/CurriculumForm';
import CurriculumView from './Curriculums/CurriculumView';
import ContentForm from './Contents/ContentForm';
import ContentView from './Contents/ContentView';
// import MeetingForm from './Meetings/MeetingForm';
// import MeetingsPage from './Meetings/MeetingsPage';
import QuestionForm from './Questions/QuestionForm';
import StaticPagesView from './StaticPages/StaticPagesView';
import StudentForm from './Student/StudentForm';
import StudentPage from './Student/StudentPage';
import InstructorForm from './Instructor/InstructorForm';
import InstructorPage from './Instructor/InstructorPage';
import AddCourseForm from './Courses/AddCourseForm'
import ContentList from './Courses/ContentList'
import { AuthConsumer } from 'shared/contexts/AuthContext';
import SubCategoryPage from './Categories/SubCategoryPage';
import SubCategoryForm from './Categories/SubCategoryForm';
import StudentCourseContentReport from './Reports/StudentCourseContentReport';
import MyCoursesDetails from './MyCourses/MyCoursesDetails';
import ContentDetailsPage from './ContentDetails/ContentDetailsPage';
import ContentDetailsPageAdmin from './ContentDetails/ContentDetailsPageAdmin';
import UpcommingCourses from './UpcommingCourses/UpcommingCourses';
import AdminInstructorRating from './InstructorReview/AdminInstructorRating';
type Props = {}

const LayoutAdmin: React.FunctionComponent<Props> = () => {
    const AppLayout = DesktopAdminLayout;
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    <Route exact>
                      <Redirect to={'/login'}/>
                    </Route>
                ) : (
                <AppLayout>
                    <Switch>
                        <Route exact path="/pages/:mode" component={StaticPagesView}/>
                        <Route exact path="/my/profile" component={ProfilePage}/>

                        {/* <Route exact path="/users" component={UsersPage}/>
                        <Route exact path="/users/:mode" component={UserForm}/>
                        <Route exact path="/users/:id/:mode" component={UserForm}/> */}
                        <Route exact path="/student" component={StudentPage}/>
                        <Route exact path="/student/:mode" component={StudentForm}/>
                        <Route exact path="/student/:id/:mode" component={StudentForm}/>
                        <Route exact path="/instructor" component={InstructorPage}/>
                        <Route exact path="/instructor/:mode" component={InstructorForm}/>
                        <Route exact path="/instructor/:id/:mode" component={InstructorForm}/>

                        <Route exact path="/badges" component={BadgesPage}/>
                        <Route exact path="/badges/:mode" component={BadgeForm}/>
                        <Route exact path="/badges/:id/:mode" component={BadgeForm}/>

                        <Route exact path="/banners" component={BannersPage}/>
                        <Route exact path="/banners/:mode" component={BannerForm}/>
                        <Route exact path="/banners/:id/:mode" component={BannerForm}/>
{/* 
                        <Route exact path="/packages" component={PackagesPage}/>
                        <Route exact path="/packages/:mode" component={PackageForm}/>
                        <Route exact path="/packages/:id/:mode" component={PackageForm}/> */}

                        {/* <Route exact path="/static-pages" component={StaticPagesPage}/>
                        <Route exact path="/static-pages/:id/:mode" component={StaticPageForm}/> */}


                        <Route exact path="/reviews" component={ReviewsPage}/>


                        <Route exact path="/categories" component={CategoriesPage}/>
                        <Route exact path="/categories/:mode" component={CategoryForm}/>
                        <Route exact path="/categories/:id/:mode" component={CategoryForm}/>

                        <Route exact path="/:id/sub-categories" component={SubCategoryPage}/>
                        <Route exact path="/:subCatId/sub-category/create" component={SubCategoryForm}/>
                        <Route exact path="/sub-category/:id/:mode" component={SubCategoryForm}/>

                        <Route exact path="/levels" component={LevelsPage}/>
                        <Route exact path="/levels/:mode" component={LevelForm}/>
                        <Route exact path="/levels/:id/:mode" component={LevelForm}/>


                        <Route exact path="/courses" component={CoursesPage}/>
                        <Route exact path="/courses/:mode" component={AddCourseForm}/>
                        <Route exact path="/courses/:id/view" component={ContentList}/>
                        {/* <Route exact path="/courses/:id/:mode" component={CourseForm}/> */}
                        <Route exact path="/courses/:id/edit" component={AddCourseForm}/>
                        <Route exact path="/courses/:id/:mode" component={CourseForm}/>


                        <Route exact path="/courses/:courseId/curriculums/:mode" component={CurriculumForm}/>
                        <Route exact path="/courses/:courseId/curriculums/:id/view" component={CurriculumView}/>
                        <Route exact path="/courses/:courseId/curriculums/:id/:mode" component={CurriculumForm}/>

                        {/* <Route exact path="/courses/:courseId/meetings/:mode" component={MeetingForm}/> */}

                        <Route exact path="/courses/:courseId/curriculums/:curriculumId/contents/:contentId/questions/:mode"
                            component={QuestionForm}/>
                        {/* <Route exact path="/courses/:courseId/curriculums/:curriculumId/contents/:contentId/questions/:id/view"
                            component={QuestionForm}/> */}
                            <Route exact path="/courses/:courseId/curriculums/:curriculumId/contents/:contentId/questions/:id/edit"
                            component={QuestionForm}/>

                        <Route exact path="/courses/:courseId/curriculums/:curriculumId/contents/:mode"
                            component={ContentForm}/>
                        {/* <Route exact path="/courses/:courseId/curriculums/:curriculumId/contents/:id/view"
                            component={ContentView}/> */}
                        {/* <Route exact path="/courses/:courseId/curriculums/:curriculumId/contents/:id/:mode"
                            component={ContentForm}/> */}
                        <Route exact path="/courses/:courseId/curriculums/:curriculumId/contents/:id/edit"
                            component={ContentView}/>

                        <Route exact path="/courses/:courseId/curriculums/:curriculumId/contents/:id/view" component={ContentDetailsPageAdmin}/>
                        <Route exact path="/reports/:type" component={Reports}/>
                        <Route exact path="/training-schedule" component={UpcommingCourses} />
                        <Route exact path="/instructor-ratings" component={AdminInstructorRating} />
                        <Route exact path="/reports/:type/:id" component={Reports}/>
                        <Route exact path="/reports/users/:userId/course/:courseId" component={StudentCourseContentReport}/>
                        <Route exact>
                            <Redirect to={'/courses'}/>
                        </Route>
                    </Switch>
                </AppLayout>
                )
            }
        </AuthConsumer>
    );
};

export default LayoutAdmin;
